// @ts-nocheck
import { fetchData } from '../utils';
import type { Filter } from '../types/podlet';
import type { ReklameConfiguration } from '../types/reklameMaster';
import { DeviceType } from '../types/ast';

export async function getSearchReklameConfig(
    device: DeviceType,
    searchFilters: Filter,
    baseUrl: string,
) {
    const url = `${baseUrl}/search-config`;
    try {
        const { search_key, ...search_filters } = searchFilters;

        const body = {
            platform: 'web',
            device: device === 'mobile' ? 'phone' : device,
            search_key,
            search_filters: search_filters || {},
        };

        const response = await fetchData(url, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        return response as ReklameConfiguration;
    } catch (e) {
        throw new Error(`Unable to get reklame configuration - error: ${e}`);
    }
}
